
import Vue from 'vue'

import { Context } from '@nuxt/types'
import { MetaInfo } from 'vue-meta'

import AuroraBackground from '~/components/common/aurora-background.vue'
import TextPressure from '~/components/common/text-pressure.vue'
import FooterNew from '~/components/FooterNew.vue'
import TextPressureMixin from '~/mixins/text-pressure.vue'
import { NewsContent, WorkContent } from '~/models/'
import { CommunityType } from '~/models/community'
import SpecialistCulture from '~/sections/specialist/culture.vue'
import SpecialistFaq from '~/sections/specialist/faq.vue'
import SpecialistGeneralistCta from '~/sections/specialist/generalist-cta.vue'
import SpecialistIntro from '~/sections/specialist/intro.vue'
import SpecialistKv from '~/sections/specialist/kv.vue'
import RecruitPeople from '~/sections/specialist/people.vue'
import SpecialistProject from '~/sections/specialist/project.vue'
import RecruitRecruitLinks from '~/sections/specialist/recruit-links.vue'
import SpecialistTechnologicalArea from '~/sections/specialist/technological-area.vue'

export default Vue.extend({
  name: 'SpecialistPage',
  components: {
    TextPressure,
    AuroraBackground,
    SpecialistKv,
    SpecialistIntro,
    SpecialistTechnologicalArea,
    SpecialistProject,
    SpecialistCulture,
    SpecialistFaq,
    RecruitRecruitLinks,
    RecruitPeople,
    SpecialistGeneralistCta,
    FooterNew
  },
  mixins: [TextPressureMixin],
  layout: 'home',

  async asyncData({ $content }: Context): Promise<object | void> {
    const handleError = (err: Error) => {
      // eslint-disable-next-line no-console
      console.log(err)
    }
    const works = await $content('work/detail')
      .sortBy('publishedAt', 'desc')
      .only(['eyeCatchImage', 'title', 'tags', 'slug', 'publishedAtStr'])
      .limit(4)
      .fetch()
      .catch(handleError)

    const communityItems = await $content('community')
      .sortBy('eventDate', 'desc')
      .limit(3)
      .fetch()
      .catch(handleError)

    const kaggleNews = await $content('news/detail')
      .where({ tags: { $contains: ['Kaggle'] } })
      .sortBy('publishedAt', 'desc')
      .limit(3)
      .fetch()
      .catch(handleError)

    return { works, communityItems, kaggleNews }
  },

  data() {
    return {
      works: [] as WorkContent[],
      communityItems: [] as CommunityType[],
      kaggleNews: [] as NewsContent[]
    }
  },

  head(): MetaInfo {
    const title = 'SPECIALIST | DeNA×AI'
    const extendMeta = this.$helper.setMetaTitleAndDescription(title)

    return {
      title,
      meta: [...extendMeta]
    }
  }
})
